import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-fieldtype",
  templateUrl: "./field-set-fieldtype.component.html",
})
export class FieldSetFieldtypeComponent {
  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
